


























import { Component, Prop, Vue } from 'vue-property-decorator';
import LbzState from '../state/state.vue';

@Component({
  components: {
    LbzState
  }
})
export default class LbzCard extends Vue {
  // tag: 'div' (default), 'a', 'x'
  @Prop({ type: String, default: 'div' }) private tag!: string;

  // type: 'elevated' (default), 'outlined'
  @Prop({ type: String, default: '' }) private type!: string;
  // background: 'primary', 'secondary', 'surface' (default), 'error', 'light', 'dark'
  @Prop({ type: String, default: '' }) private background!: string;
  // darkened: true, false (default)
  @Prop({ type: Boolean, default: false }) private darkened!: boolean;
  // disabled: true, false (default)
  @Prop({ type: Boolean, default: false }) private disabled!: boolean;
  // ripple: undefined (default), true, false
  @Prop({ type: Boolean, default: undefined }) private ripple!: boolean;

  get cgetStateAttrs(): LbzStateAttributes {
    return {
      class: 'lbz-card__state',
      type: ['primary', 'secondary', 'error'].includes(this.background)
        ? 'primary'
        : '',
      background: this.background ? `on-${this.background}` : '',
      darkened: this.darkened,
      ripple: this.ripple
    };
  }
}
